export class GetGdsgInventoryReportConfigurationResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "environmentId",
            "baseName": "environmentId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "displayName",
            "baseName": "displayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceBucketName",
            "baseName": "sourceBucketName",
            "type": "string",
            "format": ""
        },
        {
            "name": "metadataFields",
            "baseName": "metadataFields",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "reportFormat",
            "baseName": "reportFormat",
            "type": "GdsgInventoryReportFormat",
            "format": ""
        },
        {
            "name": "csvOptions",
            "baseName": "csvOptions",
            "type": "GdsgInventoryReportCsvOptions",
            "format": ""
        },
        {
            "name": "destinationBucketName",
            "baseName": "destinationBucketName",
            "type": "string",
            "format": ""
        },
        {
            "name": "destinationPrefix",
            "baseName": "destinationPrefix",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "frequencyOptions",
            "baseName": "frequencyOptions",
            "type": "GdsgInventoryReportFrequencyOptions",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return GetGdsgInventoryReportConfigurationResponse.attributeTypeMap;
    }
    constructor() {
    }
}
